import jQuery from 'jquery';
import fetchOddsTable, { getUrl } from './helpers/fetchOddsTable';
import hideNavTab from './helpers/hideNavTab';
import initOdds from '../oddsTabHandler';

const renderHiddenTable = () => {
    fetchOddsTable().then((oddsTable) => {
        jQuery('.RC-runnerRowWrapper').after(oddsTable);
        jQuery('.js-RC-oddsPriceContainer').hide();
        initOdds();
    });
};

const openPopup = () => {
    const rowHeight = 31;
    const tfootHeight = 160;
    const theadHeight = 70;
    const reserveHeight = 50;

    const height = reserveHeight + tfootHeight + theadHeight
        + (rowHeight * jQuery('.js-RC-runnerRow').length);
    const width = 800;

    const left = (screen.width / 2) - (width / 2);
    const top = (screen.height / 2) - (height / 2);
    const params = `status=no,centerscreen=yes,
        location=no,toolbar=no,menubar=no,
        width=${width},height=${height},left=${left},top=${top}`;

    window.open(getUrl(), 'odds-table', params);
};

const variant4 = () => {
    hideNavTab();
    jQuery(document.body).addClass('odds-var4');

    const $btn = jQuery('.js-odds-variant4-btn');
    if (!$btn.length) { return; }

    renderHiddenTable();
    $btn.show();
    $btn.click(openPopup);
};

export default variant4;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/variant4.js